import React, {Fragment,useState} from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { FaEyeSlash,FaEye,FaRegWindowClose,FaLock } from "react-icons/fa";
import axios from 'axios';

export const ModalLogin = (props) => {
    const history = useHistory();
    const location = useLocation();
    const recaptchaRef = React.createRef();
    const [aceptCaptha, setAceptCaptha] = useState(false);
    const onChange = (value) => {
        setAceptCaptha(true)
      }

    const [usuarioRegistrado, setusuarioRegistrado] = useState(false);
    const [usuarioRecupera, setusuarioRecupera] = useState(false);

    const [messageLogin, setmessageLogin] = useState('');
    const messageLoginChange = (val) => {
        setmessageLogin(val)
    }

    const [formIsInvalid, setformIsInvalid] = useState(false);
    const formIsInvalidChange = (val) => {
        setformIsInvalid(val)
    }

    const [verPass, setVerPass] = useState(false);
    const verPassChange = () => {
        setVerPass(verPass? false : true)
    }
    const [nombreData, setNombreData] = useState(null);
    const nombreChange = (val) => {
        setNombreData(val.target.value)
    }
    const [usuarioData, setUsuarioData] = useState(null);
    const usuarioChange = (val) => {
        setUsuarioData(val.target.value)
    }
    
    const [passData, setPassData] = useState(null);
    const passChange = (val) => {
        setPassData(val.target.value)
    }

    const irRegistro = () => {
        props.modaToggle(false)
        history.push("/registro")
    }

    const limpiaformularios = () => {
        setNombreData('')
        document.getElementById('nombre').value = ''
        document.getElementById('usuario') !=null &&(document.getElementById('usuario').value = '')
        setUsuarioData('')
        setPassData('')
        document.getElementById('inlineFormInputGroupUsername2').value = ''
        setformIsInvalid(false)
        setmessageLogin('')
    }

    const doLogin = async () => {
        try {
            var dataForm = {
                "email":nombreData,
                "password": passData
            }
            let axiosConfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },  
              };
            await axios.post(`${process.env.REACT_APP_URL_API}auth/LoginMail`, dataForm, axiosConfig)
            .then(resLogin => {
                if(resLogin.status === 200){
                    if(resLogin.data === 'error'){
                        messageLoginChange('Email o contraseña incorrectos. <BR/> Debes registrarte primero para acceder al contenido.')
                    }else{
                        localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-idu`, resLogin.data.data.idUsuario) 
                        localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-nombre`, resLogin.data.data.usuario) 
                        localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-token`, resLogin.data.data.token) 
                        localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-id`, resLogin.data.data.claveUsuario)
                        localStorage.setItem(`${process.env.REACT_APP_ID_STORAGE}-email`, resLogin.data.data.email)
                        props.logEvento(null,false,'Login','true')
                        props.modaToggle(false)
                        
                        formIsInvalidChange(false)
                        props.activateAuth()
                        window.location.reload(false)
                        
                    }
                }else{
                    messageLoginChange('Email o contraseña incorrectos. <BR/> Debes registrarte primero para acceder al contenido.')
                }

            })
              
        } catch (error) {
            //setloaddata(false);
            messageLoginChange('Email o contraseña incorrectos. <BR/> Debes registrarte primero para acceder al contenido.') 
            formIsInvalidChange(true)
        }
    }

    const doRecovery = async () => {
        try {
            var dataForm = {
                "Email":nombreData
            }
            let axiosConfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },  
              };
            await axios.post(`${process.env.REACT_APP_URL_API}auth/RecuperarCuenta`, dataForm, axiosConfig)
            .then(resLogin => {
                if(resLogin.status === 200){
                    if(resLogin.data === 'error'){
                        messageLoginChange('Email incorrecto')
                    }else{
                        setusuarioRecupera(true)
                       // props.modaToggle(false)
                       // props.showRecoveryToggle(false)
                       // props.showRegistroToggle(false)
                        
                    }
                }else{
                    messageLoginChange('Email incorrecto')
                }

            })
              
        } catch (error) {
            //setloaddata(false);
            messageLoginChange('Email incorrecto') 
            formIsInvalidChange(true)
        }
    }

    const doRegistro = async () => {
        
        try {
            var dataForm = {
                "email":nombreData,
                "usuario":usuarioData,
                "password": passData
            }
            let axiosConfig = {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },  
              };
            await axios.post(`${process.env.REACT_APP_URL_API}auth/registroweb`, dataForm, axiosConfig)
            .then(resLogin => {
                if(resLogin.status === 200){
                    if(resLogin.data === 'error'){
                        messageLoginChange('Email ya existe')
                    }else{

                        setusuarioRegistrado(true)
                       
                         // props.modaToggle(false)
                        // props.showRecoveryToggle(false)
                        // props.showRegistroToggle(false)   
                    
                        
                    }
                }else{
                    messageLoginChange('Email ya existe')
                }

            })
              
        } catch (error) {
            //setloaddata(false);
            messageLoginChange('Email ya existe') 
            formIsInvalidChange(true)
        }
    }

    return  (
        <Fragment>
            <div className='Modal' onClick={(e) => { e.stopPropagation() ;  props.modaToggle(false)} }>
                <div className='ContentModal' onClick={(e) => { e.stopPropagation() } }>

                { usuarioRegistrado || usuarioRecupera ?
                    <div className='ContentPlayerVideo'>
                        <div className="row justify-content-md-end">
                            <div className="col-md-12 col-lg-7">
                                    
                                <div className="text-center">
                                    <div className="iconsesion-modal">
                                        <div className="circle badge-danger"><img src={process.env.PUBLIC_URL + '/assets/images/lock.svg'}/></div>
                                        {usuarioRegistrado && 'Crear cuenta gratuita' }
                                       
                                    </div>
                                    <div>
                                         {usuarioRegistrado && 
                                            <Fragment>
                                            <h3>Tu registro se ha realizado correctamente.</h3>
                                            <p>A partir de este momento ya puedes inscribirte en los webinars y tutoriales.</p>
                                            </Fragment>
                                         }
                                         {usuarioRecupera && 
                                            <Fragment>
                                            <h3>Recuperar contraseña</h3>
                                            <p>Se ha enviado un email a tu cuenta para cambiar tu contraseña</p>
                                            </Fragment>
                                         }
                                        
                                        <button className="btn btn-danger btn-form" type="button"  onClick={() => props.modaToggle(false)}  >Aceptar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    : 
                    <div className='ContentPlayerVideo'>
                        <div className="container">
                        
                        <div className="row justify-content-md-end">
                           
                            <div className="col-md-12 col-lg-7">
                                
                                <div className="text-center">
                                    
                                    <div className="iconsesion-modal">
                                        <div className="circle badge-danger"><img src={process.env.PUBLIC_URL + '/assets/images/lock.svg'}/></div>
                                        {!props.showRecovery ? !props.showRegistro ? 'Iniciar sesión' : 'Crear cuenta gratuita' : 'Recuperar contraseña'}
                                    </div>
                                    <div dangerouslySetInnerHTML={{__html: messageLogin} }/>
                                </div>
                                {!props.showRecovery ? 


                                !props.showRegistro ?
                                
                                <form className="form" onSubmit={(e) =>{ e.preventDefault(); doLogin()}}>
                                    <div className="form-group mb-2 mr-sm-2">
                                        <input className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  type="text" id="nombre" name="nombre" placeholder="Email" required  onChange={ nombreChange } /><br/>
                                    </div>
                                    <div className="input-group mb-2 mr-sm-2">
                                        <input type={verPass ? 'text' : 'password' } autoComplete="off" className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  id="inlineFormInputGroupUsername2" placeholder="Contraseña" required  onChange={ passChange } />
                                        <div className="input-group-prepend" onClick={ verPassChange }>
                                            <div className="input-group-text pointer" >
                                                {
                                                    !verPass ? <FaEyeSlash /> : <FaEye />  
                                                }
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div className="inline-block">
                                        <div class="form-group">
                                            <div class="form-check">
                                            <div className="pointer text-primary" onClick={() =>{props.showRegistroToggle(true); limpiaformularios()} }>¿Aún no estás registrado?</div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="pointer text-primary" onClick={() =>{props.showRecoveryToggle(true); limpiaformularios()}  }>¿Has olvidado tu contraseña?</div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <button className="btn btn-danger btn-form" type="submit"  >Acceder</button>
                                    </div>
                                </form>
                                :
                                    <form className="form" onSubmit={(e) =>{ e.preventDefault(); doRegistro()}}>
                                        <div className="form-group mb-12 mr-sm-12">
                                            <input className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  type="text" id="usuario" name="usuario" placeholder="Alias" required  onChange={ usuarioChange } /><br/>
                                        </div>
                                        <div className="form-group mb-12 mr-sm-12">
                                            <input className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  type="email" id="nombre" name="nombre" placeholder="Email" required  onChange={ nombreChange } /><br/>
                                        </div>
                                        <div className="input-group mb-12 mr-sm-12">
                                            <input type={verPass ? 'text' : 'password' } autoComplete="off" className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  id="inlineFormInputGroupUsername2" placeholder="Contraseña" required  onChange={ passChange } />
                                            <div className="input-group-prepend" onClick={ verPassChange }>
                                                <div className="input-group-text pointer" >
                                                    {
                                                    ! verPass ? <FaEyeSlash /> : <FaEye />  
                                                    }
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group mb-12 mr-sm-12">
                                            <div class="form-check-row">
                                                <input type="checkbox" className="politica" id="politica" required />
                                                <label class="form-check-label" for="exampleCheck1">Acepto la <Link target="_blank" to="/politicadeprivacidad" >Política de Privacidad</Link></label>
                                            </div>
                                        </div>
                                        <div className="captcha">
                                            <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey="6Lfso_4ZAAAAACvxcgENu4ZlutKf3CfJy1z7pkrh"
                                                onChange={onChange}
                                            />
                                        </div>
                                        <br/>
                                        <div className="form-group">
                                            <button className="btn btn-danger btn-form" type="submit" disabled={!aceptCaptha} >Enviar</button>
                                        </div>
                                        
                                    </form> 
                                :
                                <form className="form" onSubmit={(e) =>{ e.preventDefault(); doRecovery()}}>
                                <div className="txt-aviso">Introduce tu email y te enviaremos un enlace para restablecer la contraseña</div>
                                    <div className="form-group mb-2 mr-sm-2">
                                        <input className={formIsInvalid ? 'form-control is-invalid' : 'form-control'}  type="text" id="nombre" name="nombre" placeholder="Dirección de email" required  onChange={ nombreChange } /><br/>
                                    </div>
                                    <div className="captcha">
                                    <ReCAPTCHA
                                        ref={recaptchaRef}
                                        sitekey="6Lfso_4ZAAAAACvxcgENu4ZlutKf3CfJy1z7pkrh"
                                        onChange={onChange}
                                    /></div>
                                    <div className="form-group">
                                        <button className="btn btn-danger btn-form" type="submit" disabled={!aceptCaptha}  >Enviar</button>
                                    </div>
                                    <div className="inline-block">
                                        <div>
                                        <div className="pointer text-primary" onClick={() =>props.showRecoveryToggle(false) }>Iniciar sesión</div>
                                        </div>
                                    </div>
                                    
                                </form>                    
                                }
                                
                                

                            </div>
                            
                        </div>
                        </div>
                        
                        
                    </div> }
                </div>
            </div>
        </Fragment> 
    )
    
}